interface SelectedObjectIdentity {
    id: string;
}

export type RepeatedSelectionBehavior = 'reselect' | 'preserve' | 'unselect';

export const getRepeatedSelectionBehavior = (button?: number): RepeatedSelectionBehavior => {
    if (button === 2) return 'preserve';
    if (button === 0) return 'unselect';
    return 'reselect';
};

export const shouldPreserveSelectionForContextClick = (
    clickedObjectIDs: readonly string[],
    previouslySelectedObjects: readonly SelectedObjectIdentity[],
    button?: number
): boolean => button === 2
    && clickedObjectIDs.some(clickedID =>
        previouslySelectedObjects.some(selected => selected?.id === clickedID));
